import { useSelector, useDispatch } from "react-redux";
import { toggleColorMode } from "../../store/uiSlice";
import "./ColorModeToggle.scss";

const ColorModeToggle = () => {
  const dispatch = useDispatch();
  const colorMode = useSelector((state) => state.ui.colorMode);

  return (
    <div className="color-mode-switcher" onClick={() => dispatch(toggleColorMode())}>
      <div className={`switch ${colorMode}`}>
        <img className="icon light-icon" src="/icons/light-mode.svg" alt="Light Mode" />
        <img className="icon dark-icon" src="/icons/dark-mode.svg" alt="Dark Mode" />
        <div className="slider"></div>
      </div>
    </div>
  );
};

export default ColorModeToggle;
